import { Text } from '@shared/components/Text';
import { API } from '@shared/types/api';

interface MBSentBySMSProps {
  message: API.ChatMessageFragment;
}

/*
    Simple text indicating that the message has been sent by SMS
*/
export function MBSentBySMS({ message }: MBSentBySMSProps) {
  if (!message.urgent && !message.sentBySMS) {
    return null;
  }
  return (
    <Text size="caption1" inactive style={{ paddingTop: '2px' }}>
      Sent by SMS
    </Text>
  );
}
